export default "__VITE_ASSET__CZoqHVFc__"